/** Situações da entidade TabelaPreco */
export interface TabelaPrecoItemTipoPrecificacao {
    id: number,
    nome: string;
    abreviacao: string;
}

export const tipoPrecificacaoValorUnitarioFixo: TabelaPrecoItemTipoPrecificacao = {id: 1, nome: 'Valor Unitário Fixo', abreviacao: 'Fixo'};
export const tipoPrecificacaoValorUnitarioMinimoMaximo: TabelaPrecoItemTipoPrecificacao = {id: 2, nome: 'Valor Unitário Mínimo e Máximo', abreviacao: 'Mín. e Máx.'};
export const tipoPrecificacaoValorUnitarioQuantidade: TabelaPrecoItemTipoPrecificacao = {id: 3, nome: 'Valor Unitário por Quantidade', abreviacao: 'Por Quantidade'};

export const tiposPrecificacoes: TabelaPrecoItemTipoPrecificacao[] = [
    tipoPrecificacaoValorUnitarioFixo,
    tipoPrecificacaoValorUnitarioMinimoMaximo,
    tipoPrecificacaoValorUnitarioQuantidade
];


/** Verifica se o tipo precificação é Valor Unitário Fixo */
export function isTipoPrecificacaoValorUnitarioFixo(tipoPrecificacao: number): boolean {
    return tipoPrecificacao === tipoPrecificacaoValorUnitarioFixo.id;
}

/** Verifica se o tipo precificação é Valor Unitário Mínimo e Máximo */
export function isTipoPrecificacaoValorUnitarioMinimoMaximo(tipoPrecificacao: number): boolean {
    return tipoPrecificacao === tipoPrecificacaoValorUnitarioMinimoMaximo.id;
}

/** Verifica se o tipo precificação é Valor Unitário por Quantidade */
export function isTipoPrecificacaoValorUnitarioQuantidade(tipoPrecificacao: number): boolean {
    return tipoPrecificacao === tipoPrecificacaoValorUnitarioQuantidade.id;
}
